export const TRANSITIONS = {
    DURATION: 0.1,
    EASE: [0.32, 0.72, 0, 1],
};
export const VELOCITY_THRESHOLD = 0.1;
export const CLOSE_THRESHOLD = 0.1;
export const SCROLL_LOCK_TIMEOUT = 100;
export const BORDER_RADIUS = 8;
export const NESTED_DISPLACEMENT = 16;
export const WINDOW_TOP_OFFSET = 26;
export const DRAG_CLASS = 'vaul-dragging';
